'use client';

import { usePathname } from '@/lib/next/navigation';
import { isAdminPath } from '@/lib/admin-routes';
import { type ScopeLeaf, useScopeTree } from '@/hooks/use-scope-tree';
import { useSelectedScopes } from '@/hooks/use-selected-scopes';
import { useAdminScopeStore } from '@/stores/admin-scope-store';

/**
 * The single org the current page context operates on:
 * - admin area → the ConfigSwitcher configuration (admin scope store);
 * - elsewhere → the first configuration of the global view selection.
 *
 * Null while the tree is loading or when nothing is reachable.
 */
export function useContextOrg(): ScopeLeaf | null {
	const pathname = usePathname();
	const { leaves } = useScopeTree();
	const { scopes } = useSelectedScopes();
	const adminConfigId = useAdminScopeStore((s) => s.configId);

	if (isAdminPath(pathname)) return leaves.find((l) => l.orgId === adminConfigId) ?? null;
	return scopes[0] ?? null;
}
